import React from 'react'
import PropTypes from 'prop-types'
import Immutable from 'immutable'
import { Form } from 'reactstrap'
import { reduxForm } from 'redux-form'
import SelectionableTable from '../../../common/forms/table/SelectionableTable'
import { LEGAL_CARGO_COLUMNS } from '../../../../config/columns'
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants'
import FormFooter from '../../../common/forms/FormFooter'

const LegalCargoTableForm = ({ loading, legalCargos, handleSubmit }) => (
  <Form onSubmit={handleSubmit}>
    <SelectionableTable
      columns={LEGAL_CARGO_COLUMNS}
      data={legalCargos.toJS()}
      name="items"
      loading={loading}
      manual={false}
      defaultPageSize={DEFAULT_PAGE_SIZE}
      returnOnlySelectedItems
      filterable
      emptyText="No hay resultados para mostrar."
      keyField="idSourceSystem"
      required
      form="LegalCargoTableForm"
    />
    <FormFooter
      saveButtonText="Exportar"
      saveButtonIcon="fa fa-file-excel-o"
    />
  </Form>
)

LegalCargoTableForm.propTypes = {
  loading: PropTypes.bool.isRequired,
  legalCargos: PropTypes.instanceOf(Immutable.List).isRequired,
  handleSubmit: PropTypes.func.isRequired,
}

export default reduxForm({
  form: 'LegalCargoTableForm',
})(LegalCargoTableForm)